import { ToggleCompletedStatusFilter } from "components/filters/ToggleCompletedStatusFilter";
import React from "react";
import { AutocompleteInput, DateTimeInput, Filter, ReferenceInput, useTranslate } from "react-admin";

import TextInputEx from "../../../components/_extensions/react-admin/input/TextInputEx";

export const OrderImportTracksFilters = (props) => {
    const translate = useTranslate();

    return (
        <Filter {...props}>
            <ToggleCompletedStatusFilter source="state" defaultValue={undefined} alwaysOn key="state" />

            <DateTimeInput source="created_at.created_at_from" label={translate("osfc.filters.created_at.from")} resettable />
            <DateTimeInput source="created_at.created_at_to" label={translate("osfc.filters.created_at.to")} resettable />

            <ReferenceInput source="created_by" reference="users" perPage={15} filter={{ no_range: false }}>
                <AutocompleteInput optionText="full_name" resettable />
            </ReferenceInput>

            <TextInputEx source="id" resettable key="id" />
            <TextInputEx source="file_src" resettable key="file_src" />
        </Filter>
    );
};